import { ReactNode } from 'react';

export enum ProductModule {
    HOT = 'HOT',
    HOT2 = 'HOT2',
    NORMAL = 'NORMAL',
    NORMAL2 = 'NORMAL2',
    MEMBER = 'MEMBER',
    BUNDLE = 'BUNDLE',
    POPULAR = 'POPULAR',
    REFURBISH = 'REFURBISH',
    REFURBISH2 = 'REFURBISH2',
    FLASH_SALE = 'FLASH_SALE',
    ACCESSORY = 'ACCESSORY',
    ACCESSORY2 = 'ACCESSORY2',
    BUY_ONE_GET_ONE = 'BUY_ONE_GET_ONE',
    BUY_ONE_GET_ONE2 = 'BUY_ONE_GET_ONE2',
    PPS_SG = 'PPS_SG',
    PPS_SG2 = 'PPS_SG2',
    BEST_SELLERS = 'BEST_SELLERS',
    BEST_SELLERS2 = 'BEST_SELLERS2',
    BEST_RECOMMEND = 'BEST_RECOMMEND',
    ACCESSORIES = 'ACCESSORIES',
    WARMUP = 'WARMUP',
    SALE = 'SALE',
}

export enum IPageStatus {
    UNKNOW = 'unknow',
    TEASER = 'teaser',
    ACTIVITY = 'activity',
    RETURN = 'return',
    END = 'end',
}

export type ITimeLine = {
    teaser: {
        start: number;
        end: number;
    };
    activity: {
        start: number;
        end: number;
    };
    return: {
        start: number;
        end: number;
    };
};

export interface IProductProps {
    module: ProductModule;
    icon: ReactNode;
    title: string;
    desc: string;
    id?: string;
    isNeedBtn?: boolean;
}

export type IProductItem = {
    id: string;
    discountPercent: string;
    disparityPrice: string;
    compareAtPrice: string;
    compareAtPrice2: string;
    imageUrl: string;
    memberPrice: string;
    memberPrice2: string;
    price: string;
    price2: string;
    points: number;
    productId: string;
    purchaseUrl: string;
    productUrl: string;
    subtitle1: string;
    subtitle2: string;
    title: string;
    variantId: string;
    inventoryQuantity: number;
    displayInventoryQuantity: number;
    checkoutNode?: string;
    discount?: string;
    pointsMultiple: string;
    products?: {
        title: string;
        series: string;
    }[];
    category?: string;
};
